import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export function PhoneCode(props) {
  return (
    <PhoneInput
      country='ae'
      enableSearch={true}
      value={props.phone}
      onChange={(phone) => props.Addphone(phone)}
    />
  );
}
